import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { 
    prazoService, 
    PrazoDto, 
    PrazoDetalheDto, 
    CriarPrazosDto, 
    AlterarPrazoDto
} from 'services/prazoService';

// Query para listar prazos
export function usePrazos(incluirInativos = false) {
    return useQuery<PrazoDto[]>({
        queryKey: ['prazos', incluirInativos],
        queryFn: () => prazoService.listar(incluirInativos),
        staleTime: 5 * 60 * 1000, // 5 minutos
    });
}

// Query para obter prazo por ID
export function usePrazo(id: number, enabled = true) {
    return useQuery<PrazoDetalheDto>({
        queryKey: ['prazo', id],
        queryFn: () => prazoService.obterPorId(id),
        enabled: enabled && id > 0,
        staleTime: 5 * 60 * 1000, // 5 minutos
    });
}

// Mutation para criar prazos
export function useCriarPrazos() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CriarPrazosDto) => prazoService.criarPrazos(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['prazos'] });
        },
    });
}

// Mutation para alterar prazo
export function useAlterarPrazo() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: { id: number; data: AlterarPrazoDto }) => 
            prazoService.alterar(id, data),
        onSuccess: (_, { id }) => {
            queryClient.invalidateQueries({ queryKey: ['prazos'] });
            queryClient.invalidateQueries({ queryKey: ['prazo', id] });
        },
    });
}

// Mutation para excluir prazo
export function useExcluirPrazo() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => prazoService.excluir(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['prazos'] });
        },
    });
}

// Mutation para reativar prazo
export function useReativarPrazo() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: number) => prazoService.reativar(id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['prazos'] });
        },
    });
}

